// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hSOFM","otpInputWrapper":"styles_otpInputWrapper__lGv0R","otpInput":"styles_otpInput__wOHb4","requestOtpButton":"styles_requestOtpButton__gBYy6"};